import React from 'react';

import useFallbackTranslation from 'utils/hooks/useFallbackTranslation';

interface VideoEmbedProps {
  youtubeId: string;
  youkuId: string;
  className?: string;
}

const VideoEmbed: React.FC<VideoEmbedProps> = ({ youtubeId, youkuId, className }) => {
  const { t } = useFallbackTranslation();

  if (!youtubeId && !youkuId) return null;
  return (
    <iframe
      className={className}
      // tabIndex={tabIndex}
      src={
        youkuId
          ? `https://player.youku.com/embed/${youkuId}`
          : `https://www.youtube.com/embed/${youtubeId}`
      }
      title={youkuId ? t('system.YouKuPlayer') : t('system.YouTubePlayer')}
      allow={
        youkuId
          ? undefined
          : 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      }
      allowFullScreen
    />
  );
};

export default VideoEmbed;
